module.exports = __webpack_public_path__ + "static/vk-icon-e81439e8ef79f40ad07493ce7c842163.jpg";